import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { DeleteChatsAction } from '../../actions/chats/delete-chats-action';
import { DeleteChatsErrorAction } from '../../actions/chats/delete-chats-error-action';
import { GetChatsAction } from '../../actions/chats/get-chats-action';

@Injectable()
export class DeleteChatsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public DeleteChats = createEffect(() => this.actions
    .pipe(
      ofType(DeleteChatsAction.type),
      mergeMap(action => {
        const deleteChatsAction = <DeleteChatsAction>action;
        return this.api.deleteChats(deleteChatsAction.chatIds).then(() => {
          return new GetChatsAction(deleteChatsAction.bijbEvent);
        }, error => {
          return new DeleteChatsErrorAction(error);
        });
      })
    ));
}
